var audio_rtlignore_default = {
  "fontElementMap": "KUSZ0",
  "container": "mbts-",
  "customPlayer": "nao9g",
  "slim": "JEGKI",
  "playPauseButton": "okGVP",
  "coverImage": "Y4-5n",
  "trackDetailsContainer": "VKE3N",
  "controlsContainer": "_5-Amj",
  "controlsGroup": "XpX1I",
  "sliderContainer": "_4QPN3",
  "audioDuration": "dx6Fu",
  "isLoading": "o7YXg",
  "audioDetails": "ud6Ps",
  "authorName": "A17fQ",
  "title": "I79Kx",
  "dropdownMenuWrapper": "cOHRb",
  "dropdownSelectedButton": "BDzJ4",
  "dropdownContent": "lc-Wf",
  "dropdownContentWithIcon": "zWuHC",
  "audioLoader": "DOfZ8"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
